import axios from 'axios';
import { toast } from 'sonner';
import { useInstitutionStore } from '@/modules/auth/presentation/store/institution.store';
import { AuthStorageDatasource } from '@/modules/auth/data/datasources/auth-storage.datasource';

const authStorage = new AuthStorageDatasource();

export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
});

// institution+courseId identificam a lista (par institution+courseId no
// backend) resolvida no login — precisam ir em toda request de relatório
// (GET e POST), senão um login com acesso a mais de uma lista fica ambíguo
// pro basicAuth. courseId sobrescreve qualquer valor fixo que o datasource
// já tenha passado em `params`.
apiClient.interceptors.request.use((config) => {
  const { institutionName, courseId } = useInstitutionStore.getState();
  if (institutionName) {
    const session = authStorage.getSession(institutionName);
    if (session) {
      config.headers.Authorization = session.token;
    }

    config.params = {
      ...config.params,
      institution: institutionName,
      ...(courseId ? { courseId } : {}),
    };
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error: unknown) => {
    const status = axios.isAxiosError(error)
      ? error.response?.status
      : undefined;
    if (status === 401 || status === 403) {
      toast.error('Credenciais inválidas. Verifique seu e-mail e senha.');
      useInstitutionStore.getState().setShowLoginModal(true);
    }
    return Promise.reject(error);
  },
);
